<template>
	<div>
		<div class="mianPage">
			<div class="topSearch">
				<el-form inline class="el-form flex_start">
					<el-form-item>
						<el-date-picker v-model="queryData.submitDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" size="small"
							placeholder="时间">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-input clearable v-model="queryData.name" size="small" style="width:210px" placeholder="公司名称"></el-input>
					</el-form-item>
					<el-form-item>
						<el-select v-model="queryData.examineStatus" clearable size="small" style="width:210px" placeholder="审核状态">
							<el-option label="待审核" :value="2"></el-option>
							<el-option label="已通过" :value="3"></el-option>
							<el-option label="已驳回" :value="4"></el-option>
						</el-select>
					</el-form-item>
					<div class="menu-right">
						<el-button @click="searchReset" size="small"
							v-hasPermi="['approvalPending:comanyQuality:query']">重置</el-button>
						<el-button type="primary" @click="confirmQuery" size="small"
							v-hasPermi="['approvalPending:comanyQuality:query']">查询</el-button>
					</div>
				</el-form>
			</div>
			<div class="approvalList">
				<div v-if="tableData.length>0">
					<div class="approvalBox" v-for="(item,index) in tableData" :key="index">
						<div class="statusTitle space_between">
							<div class="companyTxt">{{item.companyName}}</div>
							<div class="statusTxt" v-if="item.examineStatus == 2">待审核</div>
							<div class="statusTxt" v-else-if="item.examineStatus == 3" style="color: #19B21E;">已通过</div>
							<div class="statusTxt" v-else-if="item.examineStatus == 4" style="color: #FC474C;">已驳回</div>
						</div>
						<div class="infoRow flex_start">
							<div class="infoTxt">证件类型：<span>企业营业执照</span></div>
							<div class="infoTxt">统一社会信用代码：<span>{{item.number}}</span></div>
							<div class="infoTxt" style="margin-left: 60px;">营业执照：<el-button type="text"
									@click="imgPreview(item.businessPhotoUrl)" class="previewBtn">查看</el-button></div>
						</div>
						<div class="infoRow flex_start">
							<div class="infoTxt">法人/经营者：<span>{{item.legalPerson}}</span></div>
							<div class="infoTxt" v-if="item.certStatus == 1">证件有效期：<span>无截止期限</span></div>
							<div class="infoTxt" v-else-if="item.certStatus == 0">证件有效期：<span>{{item.certStartDate}} -
									{{item.certEndDate}}</span></div>
						</div>
						<div class="infoRow flex_start" v-if="item.examineStatus == 4">
							<div class="infoTxt">驳回原因：<span style="color: #FC474C;">{{item.cause}}</span></div>
						</div>
						<div class="infoRow space_between" style="margin-bottom: 0;">
							<div class="infoTxt"><span>{{item.submitDate}}</span></div>
							<div>
								<el-button type="primary" size="small" plain @click="showApprovalHistory(item)"
									v-hasPermi="['approvalPending:applicationQuality:approval']">审批历史</el-button>
								<el-button type="primary" size="small" plain @click="approvalOperation(item,4)"
									v-if="item.examineStatus == 2" v-hasPermi="['approvalPending:comanyQuality:approval']">驳回</el-button>
								<el-button type="primary" size="small" @click="approvalOperation(item,3)" v-if="item.examineStatus == 2"
									v-hasPermi="['approvalPending:comanyQuality:approval']">通过</el-button>
							</div>
						</div>
					</div>
				</div>
				<div v-else class="emptyBox">
					<el-empty description="暂无更多"></el-empty>
				</div>
				<div class="paging" style="display: flex;justify-content: flex-end;margin-top: 20px;">
					<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
						:current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="审批历史" class="el_dialogs" :visible.sync="auditHistoryVisible" width="70%"
			@close="closeAuditHistoryDialog">
			<div class="approvalLists" v-if="historyData.length>0">
				<div class="approvalBox" v-for="(item,index) in historyData" :key="index">
					<div class="statusTitle space_between">
						<div class="companyTxt">{{item.companyName}}</div>
						<div class="statusTxt" v-if="item.examineStatus == 2">待审核</div>
						<div class="statusTxt" v-else-if="item.examineStatus == 3" style="color: #19B21E;">已通过</div>
						<div class="statusTxt" v-else-if="item.examineStatus == 4" style="color: #FC474C;">已驳回</div>
					</div>
					<div class="infoRow flex_start">
						<div class="infoTxt">证件类型：<span>企业营业执照</span></div>
						<div class="infoTxt">统一社会信用代码：<span>{{item.number}}</span></div>
						<div class="infoTxt" style="margin-left: 60px;">营业执照：<el-button type="text"
								@click="imgPreview(item.businessPhotoUrl)" class="previewBtn">查看</el-button></div>
					</div>
					<div class="infoRow flex_start">
						<div class="infoTxt">法人/经营者：<span>{{item.legalPerson}}</span></div>
						<div class="infoTxt" v-if="item.certStatus == 1">证件有效期：<span>无截止期限</span></div>
						<div class="infoTxt" v-else-if="item.certStatus == 0">证件有效期：<span>{{item.certStartDate}} -
								{{item.certEndDate}}</span></div>
					</div>
					<div class="infoRow flex_start" v-if="item.examineStatus == 4">
						<div class="infoTxt">驳回原因：<span style="color: #FC474C;">{{item.cause}}</span></div>
					</div>
					<div class="infoRow space_between" style="margin-bottom: 0;">
						<div class="infoTxt"><span>{{item.submitDate}}</span></div>
						<div>
							<!-- <el-button type="primary" size="small" plain @click="showApprovalHistory(item)"
							v-hasPermi="['approvalPending:applicationQuality:approval']">审批历史</el-button> -->
							<el-button type="primary" size="small" plain @click="approvalOperation(item,4)"
								v-if="item.examineStatus == 2" v-hasPermi="['approvalPending:comanyQuality:approval']">驳回</el-button>
							<el-button type="primary" size="small" @click="approvalOperation(item,3)" v-if="item.examineStatus == 2"
								v-hasPermi="['approvalPending:comanyQuality:approval']">通过</el-button>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="emptyBox">
				<el-empty description="暂无更多"></el-empty>
			</div>
			<div class="dialogSplit"></div>
			<div class="approvalDialogBottom flex_end">
				<el-button type="primary" size="medium" @click="closeAuditHistoryDialog">关闭</el-button>
			</div>
		</el-dialog>
		<el-dialog title="驳回" :visible.sync="dialogVisible" width="28%">
			<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="rulesApi" :model="dialogFormData"
				ref="ruleForm">
				<el-form-item label="驳回原因：" prop="cause">
					<el-input clearable size="small" placeholder="请输入" v-model="dialogFormData.cause"></el-input>
				</el-form-item>
				<div class="card-bottom flex_end">
					<el-button @click="closeDialog" size="medium">取消</el-button>
					<el-button type="primary" @click="confirmDialog('ruleForm')" size="medium">确定</el-button>
				</div>
			</el-form>
		</el-dialog>
		<el-image ref="elImage" style="width: 0; height: 0;" :src="bigImageUrl" :preview-src-list="logicImageList">
		</el-image>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				// 表格查询条件
				queryData: {
					submitDate: '',
					name: '',
					examineStatus: '',
				},
				tableData: [],
				currentPage: 1,
				pageSize: 10,
				total: 0,
				bigImageUrl: '',
				logicImageList: [],

				dialogVisible: false,
				rulesApi: {
					cause: [{
						required: true,
						message: '请输入驳回原因',
						trigger: 'blur'
					}]
				},
				dialogFormData: {},

				auditHistoryVisible: false,
				historyData: [],
			}
		},
		activated() {
			if (this.$route.query.keyword) {
				this.queryData.name = this.$route.query.keyword
			}
			this.getTableData();
		},
		mounted() {
			// this.getTableData();
		},
		watch: {
			'$route.query.keyword': {
				handler(newKeyword, oldKeyword) {
					// 只有 keyword 变化时才刷新
					if (newKeyword !== oldKeyword) {
						this.queryData.name = newKeyword
						this.getTableData();
					}
				},
				immediate: true
			}
		},
		methods: {
			// 获取table数据
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
				}
				data = {
					...data,
					...this.queryData
				}
				let res = await this.$http.post(this.$api.approval.companyAuditList, data);
				this.tableData = res.data.list
				this.total = res.data.totalRecord
			},
			handleSizeChange(val) {
				this.currentPage = 1
				this.pageSize = val
				this.getTableData();
			},
			handleCurrentChange(val) {
				this.currentPage = val
				this.getTableData();
			},
			searchReset() {
				this.currentPage = 1
				this.queryData = {}
				this.getTableData();
			},
			confirmQuery() {
				this.currentPage = 1
				this.getTableData();
			},
			imgPreview(link) {
				// window.open(link, '_blank');
				this.logicImageList = [link]
				this.$nextTick(() => {
					this.$refs.elImage.clickHandler()
				})
			},
			async approvalOperation(item, type) {
				if (type == 4) {
					this.dialogVisible = true
					this.dialogFormData['id'] = item.id
				} else {
					let data = {
						examineStatus: type,
						id: item.id
					}
					let res = await this.$http.post(this.$api.approval.companyAuditStatus, data);
					if (res.code == 1) {
						this.$message.success('审批完成');
						this.closeAuditHistoryDialog();
						this.getTableData();
					}
				}
			},
			closeDialog() {
				this.dialogVisible = false
				this.dialogFormData = {}
			},
			confirmDialog(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						let data = {
							cause: this.dialogFormData.cause,
							examineStatus: 4,
							id: this.dialogFormData.id
						}
						let res = await this.$http.post(this.$api.approval.companyAuditStatus, data);
						if (res.code == 1) {
							this.$message.success('审批完成');
							this.closeDialog();
							this.closeAuditHistoryDialog();
							this.getTableData();
						}
					}
				});
			},
			showApprovalHistory(item) {
				this.auditHistoryVisible = true
				this.historyData = []
				this.getHistoryList(item);
			},
			async getHistoryList(item) {
				let data = {
					pageNum: 1,
					pageSize: 999,
					companyId: item.companyId
				}
				let res = await this.$http.post(this.$api.approval.companyAuditHistoryList, data);
				this.historyData = res.data.list
				// this.total = res.data.totalRecord
			},
			closeAuditHistoryDialog() {
				this.auditHistoryVisible = false
			},
		},
	}
</script>

<style scoped>
	.mianPage {
		padding: 10px;
	}

	.topSearch {
		background: #ffffff;
		padding: 16px;
		padding-bottom: 6px;
		border-radius: 4px;
	}

	.el-form {
		flex-wrap: wrap;
	}

	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}

	/deep/ .el-form-item {
		margin-right: 10px !important;
		margin-bottom: 10px;
	}

	.menu-right {
		margin-left: auto;
		margin-top: 4px;
		/* margin-bottom: 20px; */
	}

	.el_dialog_form /deep/ .el-form-item {
		margin-right: 0;
		margin-bottom: 20px;
	}

	.approvalList {
		background: #ffffff;
		margin-top: 10px;
		padding: 0 16px;
		padding-bottom: 10px;
		border-radius: 4px;
	}

	.approvalLists {
		padding: 0 24px;
		border-top: 1px solid #D5D5D4;
		padding-top: 10px;
		max-height: 560px;
		overflow-y: auto;
	}

	.approvalBox {
		border-bottom: 1px solid #EEEEEE;
		padding-bottom: 20px;
		padding-top: 10px;
	}

	.statusTitle {
		align-items: center;
		margin-bottom: 30px;
	}

	.companyTxt {
		font-weight: 500;
		font-size: 16px;
		color: #333333;
	}

	.statusTxt {
		font-size: 14px;
		color: #FA9600;
	}

	.infoRow {
		align-items: center;
		margin-bottom: 12px;
	}

	.infoTxt {
		font-size: 14px;
		color: #333333;
		font-weight: 500;
		min-width: 18%;
	}

	.infoTxt span {
		font-size: 14px;
		color: #666666;
	}

	.previewBtn {
		padding: 0;
	}

	.emptyBox {
		/* height: 400px; */
	}

	.el_dialogs /deep/.el-dialog__body {
		padding: 0;
	}

	.dialogSplit {
		background: #F2F5FA;
		height: 12px;
	}

	.dialogContBox {
		padding: 16px 24px;
	}

	.approvalDialogBottom {
		height: 80px;
		align-items: center;
		padding: 0 24px;
	}
</style>